import React, { useState } from 'react'

import { DocumentProspectingStep } from '../../../models/DocumentProspecting'

import { selectDocumentProspectingBaseFormValues } from '../../../store/processDocument/documentProspecting'
import { useAppSelector } from '../../../store/hooks'

import { ProspectingIntegrationSelector } from './ProspectingIntegrationSelector'
import { ProspectingDetailsForm } from './ProspectingDetailsForm'
import { ProspectingBaseForm } from './ProspectingBaseForm'
import { ProspectingSuccess } from './ProspectingSuccess'

import './DocumentProspecting.scss'

export const DocumentProspecting = () => {
  const baseFormValues = useAppSelector(selectDocumentProspectingBaseFormValues)

  const [activeStep, setActiveStep] = useState<DocumentProspectingStep>(DocumentProspectingStep.INTEGRATION)

  const handleComplete = () => {
    setActiveStep((prevState) => (prevState + 1) as DocumentProspectingStep)
  }

  const handleActivate = (prospectingStep: DocumentProspectingStep) => {
    setActiveStep(prospectingStep)
  }

  const handleRestart = () => {
    setActiveStep(DocumentProspectingStep.BASE_FORM)
  }

  if (!baseFormValues) {
    return null
  }

  if (activeStep === DocumentProspectingStep.SUCCESS) {
    return (
      <div className='h-100 w-100 d-flex flex-column align-items-center justify-content-center'>
        <ProspectingSuccess onRestart={handleRestart} />
      </div>
    )
  }

  return (
    <div className='h-100 w-100 d-flex flex-column align-items-center justify-content-center'>
      <div className='d-flex flex-column zocks-gap-3'>
        <div className='d-flex flex-column gap-2'>
          <h2>Review before creating contact</h2>
          <span className='paragraph-medium'>Your AI Assistant extracted these details. Add missing information and choose where to save.</span>
        </div>
        <div className='d-flex flex-column zocks-gap-2 document-prospecting-form-container position-relative'>
          <div className='document-prospecting-form-divider zocks-bg-color-gray-300' />
          <ProspectingIntegrationSelector activeStep={activeStep} onComplete={handleComplete} onActivate={handleActivate} />
          <ProspectingBaseForm activeStep={activeStep} onComplete={handleComplete} onActivate={handleActivate} initialBaseFormValues={baseFormValues} />
          <ProspectingDetailsForm activeStep={activeStep} onComplete={handleComplete} onActivate={handleActivate} />
        </div>
      </div>
    </div>
  )
}
